import { CourseDetailsCrossCoreqQuery } from '../../views/course_details/queries/course_details_cross_coreq_query';
import { SectionStatusServant } from '../../views/course_scheduler/servants/section_status_servant';
import { ICommand } from 'core-ts-types';
const _4 = require('lodash4');
import { CommunicatorService } from 'ui-ng-component-communicator';
import { SectionDetailsQuery } from './queries/section_details_query';
import {
  ISection,
  ISectionAvailability,
  ISectionType,
  IConflictMessage,
  IMenuSettings,
  TMenuItems
} from '../../interfaces/scheduler_interfaces';
import { SectionInfoServant, IFormattedSectionTime } from '../../views/sections/servants/section_info_servant';
import { UnscheduledSectionServant } from '../../views/unscheduled_sections/servants/unscheduled_section_servant';
import { TermCourseServant } from '../../views/term_courses/servants/term_course_servant';
import { ScheduledSectionServant } from '../../views/course_scheduler/servants/scheduled_section_servant';
import { SectionSwapServant } from '../../swap/servants/section_swap_servant';
import { SwapFacade } from '../../swap/facades/swap_facade';
import { ScheduleSectionFacade } from '../../views/registration/facades/schedule_section_facade';
import { MeetingTimeServant } from '../meeting_times/servants/meeting_time_servant';
import { ScheduledSectionStatusServant } from '../../views/course_scheduler/servants/scheduled_section_status_servant';
import { Strategy } from 'utility-ts-strategy';
import { RefreshSeatAvailabilityFacade } from '../../views/course_scheduler/facades/refresh_seat_availability_facade';

class SectionDetail {
  private isOpened: boolean = false;
  private openBound: () => void;
  private closeBound: () => void;
  private section: ISection;
  private availability: ISectionAvailability;
  private conflictingMessages: IConflictMessage[];
  private openCourseDetailModal: () => void;
  private otherSectionTypes: unknown;
  private locationAndTimes: IFormattedSectionTime[];
  private query: SectionDetailsQuery;
  private sectionLabel: string;
  private canAddToWaitlist: boolean;
  private isConflicting: boolean;
  private isMultiSection: boolean;
  private showAddToScheduleButton: boolean = false;
  private canSwap: boolean = false;
  private canDrag: boolean = false;
  private hasMultipleMeetingTimes: boolean = false;
  private isConflictWithTimeOrCampus: boolean = false;
  private sectionHasStatus: boolean = false;
  private openWaitListPrompt = false;
  private sectionDetailsMenuItems: TMenuItems;
  private sectionDetailsMenuSettings: IMenuSettings;
  private showSectionDetailsMenu: boolean = false;
  private sectionDetailsHeading = '';
  private showRefreshSeats: boolean;
  constructor(
    private FEATURE_SECTION_LABEL_NK: any,
    private schedulerConfigModel: any,
    private ngComponentCommunicatorService: CommunicatorService,
    private $stateParams: ng.ui.IStateParamsService,
    private ngTermCourseServant: TermCourseServant,
    private ngSectionInfoServant: SectionInfoServant,
    private ngScheduledSectionServant: ScheduledSectionServant,
    private ngUnscheduledSectionServant: UnscheduledSectionServant,
    private ngSectionSwapServant: SectionSwapServant,
    private ngMeetingTimeServant: MeetingTimeServant,
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant,
    private ngCourseDetailsCrossCoreqQuery: CourseDetailsCrossCoreqQuery,
    private ngSectionDetailsQuery: SectionDetailsQuery,
    private removeSelectedUnscheduledSectionCommand: ICommand,
    private getTermPinCommand: ICommand,
    private loadStudentUnavailabilityCommand: ICommand,
    private ngScheduleSectionFacade: ScheduleSectionFacade,
    private ngSwapFacade: SwapFacade,
    private ngRefreshSeatAvailabilityFacade: RefreshSeatAvailabilityFacade
  ) {}
  initialize() {
    this.query = this.ngSectionDetailsQuery;
  }

  updateSectionDetail() {
    this.section = _4.get(this.ngSectionDetailsQuery, 'result.section');
    this.sectionDetailsHeading = `${this.section._course.cd} ${this.section._course.title}`;
    this.availability = _4.get(this.section, '_availability');
    this.isConflicting = this.ngUnscheduledSectionServant.isSectionConflicting(this.section);
    this.sectionLabel = this.schedulerConfigModel.getConfigProperty(this.FEATURE_SECTION_LABEL_NK);
    this.isMultiSection = TermCourseServant.isMultiSectionCourse(this.section._course);
    this.conflictingMessages = this.ngSectionInfoServant.getConflictingMessages(this.section);

    this.otherSectionTypes = _4(this.section._course._section_types)
      .filter((sectionType) => !_4.isUndefined(sectionType.name) && sectionType.id !== this.section.section_type)
      .map((sectionType) => ({
        name: sectionType.name,
        courseNk: this.section._course.nk
      }))
      .value();
    this.isConflicting = this.ngUnscheduledSectionServant.isSectionConflicting(this.section);
    this.conflictingMessages = this.ngSectionInfoServant.getConflictingMessages(this.section);
    this.canDrag = this.ngUnscheduledSectionServant.canDragSection(this.section);
    this.canSwap = this.ngSectionSwapServant.isInSwapMode();
    this.canAddToWaitlist = this.ngUnscheduledSectionServant.canAddToWaitlist(this.section);
    this.sectionHasStatus = SectionStatusServant.hasStatus(this.section);
    this.showAddToScheduleButton = !this.canSwap && this.canDrag && !this.canAddToWaitlist && !this.sectionHasStatus;
    this.isConflictWithTimeOrCampus =
      this.ngUnscheduledSectionServant.isSectionConflictingWithBusyTimes(this.section) ||
      this.ngUnscheduledSectionServant.isSectionConflictingWithCampusPreferences(this.section);
    this.hasMultipleMeetingTimes = this.ngMeetingTimeServant.hasMultipleMeetingTimes(this.section);
    this.showRefreshSeats =
      this.ngScheduledSectionStatusServant.isSectionScheduled(this.section) ||
      this.ngScheduledSectionStatusServant.isStatusWaitlisted(this.section) ||
      this.ngScheduledSectionStatusServant.isStatusUnscheduled(this.section);
  }

  $onInit() {
    this.closeBound = this.closeModal.bind(this);
    this.openBound = this.openSectionDetailModal.bind(this);
    this.ngComponentCommunicatorService.subscribe('OPEN_SECTION_DETAIL_MODAL', this.openBound);
    this.ngComponentCommunicatorService.subscribe('CLOSE_SECTION_DETAIL_MODAL', this.closeBound);
    this.initialize();
  }

  isSectionTypeScheduled(sectionType: ISectionType) {
    return this.ngScheduledSectionServant.isSectionTypeScheduled(sectionType);
  }

  $onChanges() {
    this.initialize();
  }

  openSectionDetailModal() {
    this.isOpened = true;
    this.updateSectionDetail();
    this.buildSectionDetailsMenuItems();
  }
  closeModal() {
    this.isOpened = false;
  }

  addPressed() {
    this.removeSelectedUnscheduledSectionCommand();
    if (this.isConflictWithTimeOrCampus) {
      this.loadStudentUnavailabilityCommand(this.$stateParams.termId);
      this.openConflictConfirmModal();
    } else {
      this.scheduleSection();
    }
  }

  addToWaitlist() {
    this.getTermPinCommand(this.$stateParams.termId).then(() => {
      this.ngComponentCommunicatorService.publish('OPEN_WAITLIST_PROMPT');
    });
  }

  openConflictConfirmModal() {
    this.ngComponentCommunicatorService.publish('OPEN_CONFLICT_PROMPT');
  }

  swap() {
    this.ngSwapFacade.saveSwapToAndRedirect(this.section);
  }

  scheduleSection() {
    if (this.isConflictWithTimeOrCampus) {
      this.openConflictConfirmModal();
    } else {
      this.completeSectionMovement();
    }
  }
  completeSectionMovement() {
    this.ngScheduleSectionFacade.scheduleSection(this.section);
  }

  buildSectionDetailsMenuItems() {
    const showWaitlist = this.canAddToWaitlist && !this.isConflicting;
    const showAddToSchedule = this.showAddToScheduleButton;
    const showSwap = this.canSwap;

    this.showSectionDetailsMenu = showWaitlist || showAddToSchedule || showSwap;
    this.sectionDetailsMenuSettings = {
      subtitle: this.sectionDetailsHeading,
      capHeight: true
    };
    this.sectionDetailsMenuItems = [
      {
        value: 'refresh_seat_availability',
        title: 'Refresh Seat Availability',
        visible: this.showRefreshSeats
      },
      {
        title: 'Waitlist this time',
        value: 'waitlist',
        visible: showWaitlist
      },
      {
        title: 'Add to Schedule',
        value: 'add',
        visible: showAddToSchedule
      },
      {
        title: 'Swap',
        value: 'swap',
        visible: showSwap
      }
    ].filter((item) => item.visible);
  }

  private __onMenuItemSelected($event: CustomEvent) {
    const invokeMenuStrategy = this.__menuItemStrategy.get($event.detail.value);
    invokeMenuStrategy();
  }

  private readonly __menuItemStrategy = new Strategy({
    refresh_seat_availability: () => this.__onRefreshSeatAvailabilityTriggerEnded(),
    waitlist: () => {
      this.addToWaitlist();
      this.closeModal();
    },
    add: () => {
      this.addPressed();
      this.closeModal();
    },
    swap: () => {
      this.swap();
      this.closeModal();
    }
  });

  private __onRefreshSeatAvailabilityTriggerEnded() {
    return this.ngRefreshSeatAvailabilityFacade.refreshSeats(this.section.id);
  }
}

class SectionDetailComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {};
    this.controller = SectionDetail;
    this.templateUrl = 'capability-ng-scheduler/src/components/section_details/section_details.html';
  }
}
angular.module('capability-ng-scheduler').component('sectionDetails', new SectionDetailComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_details/section_details.ts